module.exports = __webpack_public_path__ + "static/media/renegotiation-calendar.47f487ff.svg";